<template>
    <div>
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->
        
        <!-- Chart Start -->
         <div class="row mt-4">
            <div class="col">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-10">
                            <h5 class="elegant--sub-title">
                                Scan Activity
                                <i
                                    class="fas fa-info-circle"
                                    id="average-scan-activity"
                                ></i>
                                <b-popover target="average-scan-activity" triggers="hover" placement="top">
                                    <template #title>Scan Activity</template>
                                    <div v-html="tooltip.scan_activity"></div>
                                </b-popover>
                            </h5>
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.status"
                                :options="[]"
                                placeholder="Jawa Barat"
                                class="elegant-multiselect"
                                />
                        </div>
                    </div>
                    <scan-activity-chart
                        v-if='data.scanActivityChart'
                        :data="data.scanActivityChart"
                        :filter="filter"
                    ></scan-activity-chart>
                    <div v-else class="text-center mt-5 mb-5">
                        <h2 class="pt-5 pb-5">Loading...</h2>
                    </div>
                </div>
            </div>
         </div>
        <!-- Chart End -->

        <!-- Customer Distribution Start -->
        <div class="innerBox mt-4" style="padding:0; overflow: hidden;">
            <h5 class="elegant--sub-title" style="padding: 10px 0 0px 15px;">
                Customer Distribution
                <i
                    class="fas fa-info-circle"
                    id="customer-distribution"
                ></i>
                (Last 1000 Scans)
                <b-popover target="customer-distribution" triggers="hover" placement="top">
                    <template #title>Customer Distribution</template>
                    <div v-html="tooltip.customer_distribution"></div>
                </b-popover>
            </h5>
            <customer-distribution
                v-if='data.customerDistributionMap'
                :data="data.customerDistributionMap"
            ></customer-distribution>
            <div v-else class="text-center mt-5 mb-5">
                <h2 class="pt-5 pb-5">Loading...</h2>
            </div>
        </div>
        <!-- Customer Distribution End -->

        <!-- Table Start -->
        <div class="innerBox mt-4">
            <div class="row">
                <div class="col-md-10">
                    <h5 class="elegant--sub-title">
                        Scan History
                        <i
                            class="fas fa-info-circle"
                            id="scan-history"
                        ></i>
                        <b-popover target="scan-history" triggers="hover" placement="top">
                            <template #title>Scan History</template>
                            <div v-html="tooltip.scan_history"></div>
                        </b-popover>
                    </h5>
                </div>
                <!-- <div class="col-md-2">
                    <MultiSelect 
                        v-model="vue_universal_table.filter.status"
                        :options="options.status"
                        placeholder="All Status"
                        class="elegant-multiselect"
                        />
                </div> -->
                <div class="col-md-2">
                    <button
                        class="btn btn-elegant-download"
                        @click="downloadScanHistoryExcel"
                    >Download Excel <i class="fas fa-download"></i></button>
                </div>
            </div>
            <div class="mt-3">
                <vue-universal-table
                    api_url="/api/activities/history"
                    :filter="vue_universal_table.filter"
                    :fields="vue_universal_table.fields"
                    :buttons="vue_universal_table.buttons"
                    :update="vue_universal_table.update"
                    :process_data="vue_universal_table.process_data"
                    :infinite_scroll="true"
                    @onViewMap="viewScanMap"

                    sort_order="DESC"
                    sort_by="scan_date"
                ></vue-universal-table>
            </div>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <scan-map-modal
            v-if="modal.view"
            :coordinate="modal.viewData"
            @closeModal="modal.view = false"
        ></scan-map-modal>
        <!-- Modal End -->
        
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
 
    import scanActivityChart from './children/scanActivityChart.vue'
    import customerDistribution from './children/customerDistributionMap'

    import scanMapModal from './children/scanMapModal'

    export default {
        metaInfo : {
            title : 'Customer Activities'
        },
        data () {
            return {
                modal : {
                    view : false,
                    viewData : null,
                },

                filter : {},
                data : { 
                    scanActivityChart : null,
                    customerDistributionMap : null,
                },
                options : {
                    status : ["ACTIVATE","DEACTIVATE","Not Found", "Double Scan", "Cross Scan", "Reject"],
                },
                vue_universal_table : {
                    fields : [
                        {title:"Kode QR", variable:"url"},
                        {title:"Product Name", variable:"product_name"},
                        {title:"Volume", variable:"volume"},
                        {title:"Scan Date", variable:"scan_date"},
                        {title:"Latitude", variable:"lat"},
                        {title:"Longitude", variable:"lng"},
                        {title:"Status", variable:"status"},
                    ],
                    filter : {
                        status : null,
                    },
                    update : 0,
                    buttons : [
                        {
                            title : "viewMap",
                            class : "fas fa-location",
                            condition : "data.lat != 'N/A' || data.lng != 'N/A'"
                        }
                    ],
                    process_data : `
                        for (var i in data) {
                            data[i].product_name = data[i].product_name ? data[i].product_name : 'N/A'
                            data[i].volume = data[i].volume ? (parseInt(data[i].volume))/1000 + ' Lt' : 'N/A'
                            data[i].lat = data[i].lat != 0 ? data[i].lat : 'N/A'
                            data[i].lng = data[i].lng != 0 ? data[i].lng : 'N/A'
                        }
                    `
                },
                tooltip : this.$store.state.tooltip.customer_activities
            }
        },
        components : {
            customFilter,
            // highlightStats,
            scanActivityChart,
            customerDistribution,
            scanMapModal,
        },
        mounted () {
            this.fetchData();
        },
        watch : {
            'filter' : {
                deep : true,
                handler : 'fetchData',
            },
            'vue_universal_table.filter.status' : {
                handler () {
                    this.vue_universal_table.update++;
                }
            }
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) {
                    this.filter[i] = filter[i];
                    this.vue_universal_table.filter[i] = filter[i];
                }

                //Delete unnecessary filter for the table
                delete this.vue_universal_table.filter.filter;
                // console.log(this.filter);
                this.fetchData();
                this.vue_universal_table.update++;
            },
            viewScanMap (data) {
                this.modal.viewData = JSON.parse(data);
                console.log('%cActivities.vue line:224 this.modal.viewData', 'color: #007acc;', JSON.stringify(this.modal.viewData));
                this.modal.view = true;
            },
            fetchData () {
                //Reset All Data to null
                for (var i in this.data) this.data[i] = null;

                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Get Stats
                this.$http.get(`/api/activities/overview?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.scanActivityChart = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Customer Distribution Maps
                this.$http.get(`/api/activities/map-distribution?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.customerDistributionMap = resp.data.data.filter(x=>x.lat!=0&&x.lng!=0);
                })
                .catch((err)=>{console.log(err)});
            },
            downloadScanHistoryExcel () {
                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Get Customer Distribution Maps
                this.$http.get(`/api/activities/history?pagination=false&${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.exportExcel(resp.data.data, "Scan History Download");
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }
</style>